import React from 'react';
import { useSelector } from 'react-redux';
import { Box } from '../CommonComponents/OPL/Box/Box';
import { Link } from '../CommonComponents/OPL/Link/Link';
import { Text } from '../CommonComponents/OPL/Text/Text';
import { selectIsUserClient } from '../CommonSelectors/CommonAreaSelector';
import RightCapitalLogo from './assets/logo.svg';

interface RightCapitalProps {
  clientId: string;
}

export const RightCapital = ({ clientId }: RightCapitalProps) => {
  const isClient = useSelector(selectIsUserClient);

  return (
    <Box
      height="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      gridGap="24"
    >
      <RightCapitalLogo />

      {isClient ? (
        <Link
          rel="noopener"
          variant="button"
          href={`/Consumer/RightCapital/LaunchRightCapital?ClientId=${clientId}`}
        >
          Launch RightCapital
        </Link>
      ) : (
        <Text color="neutral.500">Access available to client level users only.</Text>
      )}
    </Box>
  );
};
